
import { Canvas } from "fabric";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import { Save } from "lucide-react";
import { SaveDrawingSection } from "../SaveDrawingSection";

interface SaveToolsProps {
  canvas: Canvas | null;
  onRefreshNeeded: (refreshFn: () => void) => void;
  title: string;
  onTitleChange: (title: string) => void;
  currentDrawingId: string | null;
  onDrawingSaved: (id: string) => void;
  icon: ReactNode;
  label: string;
}

export const SaveTools = ({ 
  canvas,
  onRefreshNeeded,
  title,
  onTitleChange,
  currentDrawingId,
  onDrawingSaved,
  icon,
  label
}: SaveToolsProps) => {
  return (
    <div className="toolbar-item">
      <SaveDrawingSection 
        canvas={canvas}
        onRefreshNeeded={onRefreshNeeded}
        title={title}
        onTitleChange={onTitleChange}
        currentDrawingId={currentDrawingId}
        onDrawingSaved={onDrawingSaved}
        customTrigger={
          <button
            className="modern-toolbar-button"
            aria-label={label}
            title={currentDrawingId ? "Update or save a copy" : "Save drawing"}
          >
            {icon}
          </button>
        }
      />
    </div>
  );
};
